var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--job-index"},[_c('app-job-index'),_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"primary","fixed":"","bottom":"","right":"","fab":"","to":{
                    name: 'job-create'
                }}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-plus")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('job.action.create')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }